module.exports = __webpack_public_path__ + "static/media/chat.05506336.svg";